import { cva } from 'class-variance-authority';
export const inputVariants = cva('flex items-center rounded-lg py-2.5 text-brand-text-tertiary placeholder-brand-text-tertiary placeholder-opacity-70 disabled:opacity-50', {
    variants: {
        height: {
            default: 'h-10',
            flexible: 'min-h-10',
        },
        border: {
            default: 'border border-brand-border ring-brand-border focus-within:border-brand-border focus-within:ring-1 focus-within:ring-brand-border focus:border-brand-border focus:ring-brand-border',
            none: 'border border-transparent',
        },
        background: {
            default: 'bg-brand-background-tertiary',
            transparent: '',
        },
        leftPadding: {
            default: 'pl-3',
            none: '',
        },
        rightPadding: {
            default: 'pr-3',
            none: '',
        },
    },
    defaultVariants: {
        border: 'default',
        background: 'default',
        leftPadding: 'default',
        rightPadding: 'default',
    },
});
//# sourceMappingURL=input.js.map